import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectAuthenticated } from '../Login/selectors';
import { logout } from '../Login/actions';
import { imageUrl } from '../services/helpers';
import { Button } from '../Controls';
import { Header, Logo, Nav } from './styled';

const MainMenu = () => {
  const dispatch = useDispatch();
  const authenticated = useSelector(selectAuthenticated);

  return (
    <Header>
      <Link to="/" aria-label="Pokémon TCG home">
        <Logo src={imageUrl('/pokemon-tcg-logo.png')} alt="Pokémon Trading Card Game" />
      </Link>
      {authenticated && (
        <Nav>
          <Link to="/rules">Rules</Link>
          <Button onClick={() => dispatch(logout())}>Log out</Button>
        </Nav>
      )}
    </Header>
  );
};

export default MainMenu;
